import React from 'react';
import buildHiddenInputs from '../../../helpers/hidden_input_builder';

const hiddenInputMap = ({
  advert,
  alert_id,
  contact_mode,
  M_context_for_link,
  M_context,
  search,
}) => {
  return {
    flatshare_id: advert.id,
    action: 'sendemail',
    mode: 'contact',
    submode: contact_mode,
    flatshare_type: advert.type,
    sort_by: search.sort_by,
    offset: search.offset,
    gs_id: search.gs_id,
    gm_id: search.gm_id,
    city_id: search.city_id,
    postcode_id: search.postcode_id,
    max_rent: search.max_rent,
    location: search.location,
    alert_id: alert_id,
    M_context: M_context,
    M_context_for_link: M_context_for_link,
    search_results: search.results,
    search_id: search.id,
    featured: advert.featured,
  };
};

const HiddenInputs = (props) => <>{buildHiddenInputs(hiddenInputMap(props))}</>;

export default HiddenInputs;
